import React, {
    useEffect,
    useRef,
    useMemo,
    useState,
    useCallback,
  } from "react";
  import debounce from "lodash/debounce";
  import {
    GoogleMap,
    useJsApiLoader,
    Marker,
    Autocomplete,
  } from "@react-google-maps/api";
  import { Col } from "reactstrap";
  import { getGeocode, getLatLng } from "use-places-autocomplete";
  import CustomInput from "../../Common/CustomInput/CustomInput";
  
  const containerStyle = {
    width: "100%",
    height: "0px",
  };
  
  const MapComponent = ({ prop, setFieldValue, value, formik, x, y }) => {
    const positionRef = useRef(null);
    const [map, setMap] = useState(null);
  
    const [current, setCurrent] = useState({
      lat: x ? parseFloat(x) : 24.7136,
      lng: y ? parseFloat(y) : 46.6753,
      value: value,
    });
  
    useEffect(() => {
      if (map) {
        const bounds = new window.google.maps.LatLngBounds(current);
        map.fitBounds(bounds);
      }
    }, [current, map]);
  
    useEffect(() => {
      if (x && y) {
        setCurrent({
          lat: parseFloat(x),
          lng: parseFloat(y),
        });
      }
    }, [x, y]);
  
    const libraries = useMemo(() => ["places"], []);
    const { isLoaded } = useJsApiLoader({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
      libraries,
    });
  
    const getCode = useCallback(() => {
      if (positionRef.current && positionRef.current.value) {
        getGeocode({ address: positionRef.current.value })
          .then((results) => {
            if (results.length > 0) {
              const { lat, lng } = getLatLng(results[0]);
              const address = results[0].formatted_address;
              setFieldValue("latitude", lat);
              setFieldValue("longitude", lng);
              setFieldValue("address", address);
              setCurrent({ lat, lng });
            }
          })
          .catch((error) => {
            console.error("Error fetching geocode:", error);
          });
      }
    }, [setFieldValue]);
  
    const debouncedGetCode = useCallback(debounce(getCode, 300), [getCode]);
  
    const onUnmount = useCallback((map) => {
      setMap(null);
    }, []);
  
    const onMarkerDragEnd = (e) => {
      const { lat, lng } = e.latLng.toJSON();
      setCurrent({ lat, lng });
      setFieldValue("latitude", lat);
      setFieldValue("longitude", lng);
  
      getGeocode({ location: { lat, lng } })
        .then((results) => {
          if (results.length > 0) {
            const address = results[0].formatted_address;
            setFieldValue("address", address);
            if (positionRef.current) {
              positionRef.current.value = address;
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching address:", error);
        });
    };
  
    return (
      <>
        {isLoaded ? (
          <>
            <Col md={12} className="mb-2 p-0">
              <Autocomplete onPlaceChanged={debouncedGetCode}>
                <CustomInput
                  ref={positionRef}
                  type="text"
                  placeholder={("Address")}
                  id="address"
                  name="address"
                  defaultValue={value}
                  touched={formik.touched}
                  errors={formik.errors}
                  onBlur={formik.handleBlur}
                />
              </Autocomplete>
            </Col>
            <Col md={12} className="p-0">
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={current}
                zoom={15}
                onLoad={(map) => setMap(map)}
                onUnmount={onUnmount}
                clickableIcons
              >
                <Marker
                  position={current}
                  draggable={true}
                  onDragEnd={onMarkerDragEnd}
                />
              </GoogleMap>
            </Col>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };
  
  export default MapComponent;
  